import CheckoutPage from 'navigation/pages/CheckoutPage';
import { bindEmitterMethod } from 'helpers/bind';
import Form from 'components/form/Form';
import { forceArray } from 'navigation/component/Component';
import ReturnsItem from './partials/ReturnsItem';
class ReturnsItems extends CheckoutPage {
    initialized() {
        super.initialized();
        this.handleFormChange();
    }
    bindEvents(add = true) {
        super.bindEvents(...arguments);
        const emitterMethod = bindEmitterMethod(add);
        forceArray(this.modules.items).forEach((item) => {
            item[emitterMethod]('update:choice', this.handleItemChoiceUpdate);
            item[emitterMethod]('update:reason', this.handleItemReasonUpdate);
        });
        this.modules.form.el.addEventListener('change', this.handleFormChange);
    }
    handleFormChange = () => {
        const hasChoice = Object.keys(this.modules.form.getFormValues()).join('').includes('choice');
        if (!hasChoice) {
            this.modules.form.el.classList.add('not-valid');
            this.refs.nextStep[0].disabled = true;
        }
        else {
            this.refs.nextStep[0].disabled = false;
            this.modules.form.quickValid();
        }
    };
    handleItemChoiceUpdate = (value) => {
        this.modules.form.bindEvents(false);
        this.modules.form.parseForm();
        this.modules.form.bindEvents(true);
        this.modules.form.quickValid();
    };
    handleItemReasonUpdate = (value) => {
        this.modules.form.bindEvents(false);
        this.modules.form.parseForm();
        this.modules.form.bindEvents(true);
        this.modules.form.quickValid();
    };
    handleUpdateSize = (value) => {
        this.modules.form.bindEvents(false);
        this.modules.form.parseForm();
        this.modules.form.bindEvents(true);
        this.modules.form.quickValid();
    };
    getModulesMap() {
        return {
            form: ['.returns__items-form', Form],
            items: ['.returns__item', ReturnsItem]
        };
    }
    resize() {
        super.resize();
    }
    flush() {
        super.flush();
    }
}
export default ReturnsItems;
